// Shared SEO data used by both the client (seo.js) and the build-time
// prerender script (scripts/prerender-seo.js). CommonJS so Node can require it.
const SITE = "Hope & Favor";
const BASE = "https://hopeandfavor.com";
const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/a8b3fd7a-c0bc-4f7b-b2a7-d1acf9d102f5/images/70b7e9bfbccb9d1b3ec58419e976ce29dc84df99960aa70249a674b411d6773c.png";

const DEFAULT_DESC =
  "Hope & Favor — thoughtfully curated care boxes and Hope Cards for illness, grief, recovery, and life's hardest moments.";

const SEO_MAP = {
  "/": {
    title: "Care Boxes & Hope Cards for Life's Hardest Moments",
    description: "Send comfort that speaks. Hope & Favor curates care boxes and printable Hope Cards for illness, grief, recovery, and hard seasons.",
  },
  "/shop": {
    title: "Shop Care Boxes by Theme",
    description: "Browse Hope & Favor care boxes for cancer & illness, grief & loss, mental health, recovery, caregiving, and faith & encouragement.",
  },
  "/kit-finder": {
    title: "Kit Finder Quiz — Find Your Perfect Care Kit",
    description: "Take our 60-second Kit Finder quiz to discover the most meaningful Hope & Favor care kit for you or someone you love.",
  },
  "/build-your-own-box": {
    title: "Build Your Own Care Box",
    description: "Create a personalized care box — hand-pick comforting items and add a signature Hope Card for someone you love.",
  },
  "/digital-downloads": {
    title: "Printable Journals & Digital Downloads",
    description: "Instant printable 90-day guided journals and digital keepsakes to bring comfort, reflection, and hope.",
  },
  "/about": {
    title: "About Hope & Favor",
    description: "Our mission is to help you show up for the people you love in their hardest moments, with comfort, dignity, and hope.",
  },
  "/our-story": {
    title: "Our Story",
    description: "The heart behind Hope & Favor — why we create care boxes and Hope Cards for life's hardest seasons.",
  },
  "/blog": {
    title: "The Journal — Comfort, Care & Encouragement",
    description: "Thoughtful reads on supporting loved ones through illness, grief, and recovery, from the Hope & Favor journal.",
  },
  "/contact": {
    title: "Contact Us",
    description: "Questions about care boxes, corporate gifting, or partnerships? Reach the Hope & Favor team — we're here to help.",
  },
  "/policies": {
    title: "Policies — Shipping, Returns & Privacy",
    description: "Hope & Favor shipping, returns, refund, privacy, and fraud-prevention policies.",
  },
  "/subscriptions": {
    title: "Care Box Subscriptions",
    description: "Send ongoing comfort with a Hope & Favor subscription — thoughtfully curated care boxes delivered on a schedule.",
  },
  "/hope-cards": {
    title: "Hope & Favor™ Keepsake Hope Cards",
    description: "Hope & Favor™ Keepsake Hope Cards — collectible cards with an encouraging message, a Bible verse, a QR keepsake, and a removable charm to keep close.",
  },
  "/grace-in-action": {
    title: "Hope in Action — Warm Essentials Care Kits",
    description: "Sponsor or send a 20-piece Warm Essentials Kit — backpack, blanket, socks, and hygiene basics — for someone facing hard times.",
  },
  "/care-boxes": {
    title: "Care Boxes Program",
    description: "Signature Hope & Favor care boxes for illness, grief, recovery, and encouragement — curated with dignity and heart.",
  },
  "/corporate-care": {
    title: "Corporate Care & Gifting",
    description: "Thoughtful corporate care boxes and employee gifting to show your team and clients they're valued.",
  },
  "/church-ministry": {
    title: "Church & Ministry Care",
    description: "Partner with Hope & Favor to bring comfort and care boxes to your congregation and community.",
  },
  "/hospital-partnerships": {
    title: "Hospital Partnerships",
    description: "Bring comfort to patients and families with Hope & Favor care boxes through hospital partnerships.",
  },
  "/monthly-club": {
    title: "Monthly Care Club",
    description: "Join the Hope & Favor monthly club and send comfort and encouragement all year long.",
  },
  "/cart": {
    title: "Your Cart",
    description: "Review your Hope & Favor care boxes and Hope Cards, then check out securely.",
  },
  "/login": {
    title: "Sign In",
    description: "Sign in to the Hope & Favor account area.",
  },
};

const COLLECTION_SEO = {
  "grief-loss": { title: "Grief & Loss Care Boxes", description: "Gentle care boxes to comfort someone through grief and loss — thoughtfully curated by Hope & Favor." },
  "cancer-illness": { title: "Cancer & Illness Care Boxes", description: "Comforting care boxes for someone facing cancer or serious illness, curated with warmth and dignity." },
  "mental-health": { title: "Mental Health Care Boxes", description: "Supportive care boxes to encourage someone navigating a mental health season." },
  "recovery": { title: "Recovery Care Boxes", description: "Care boxes to comfort and encourage someone through surgery, treatment, or recovery." },
  "caregiving": { title: "Caregiver Care Boxes", description: "Care boxes that honor and support the caregivers who give so much to others." },
  "faith-encouragement": { title: "Faith & Encouragement Care Boxes", description: "Faith-filled care boxes with Scripture and encouragement for a hard season." },
  "digital": { title: "Digital Care & Printable Journals", description: "Printable journals and digital comfort keepsakes from Hope & Favor." },
};

module.exports = { SITE, BASE, OG_IMAGE, DEFAULT_DESC, SEO_MAP, COLLECTION_SEO };
